module.exports = __webpack_public_path__ + "assets/adpoly-it-whiteboards-projectors-bulk-upload-template.63711ab3.xlsx";